import { redirect } from 'react-router';

import { getCodingListsEntriesQuery, getCodingListsQuery } from '../../../queries/codingQuery';
import { companyPropertiesQuery } from '../../../queries/companyQuery';
import { allTeamsQuery, teamsQuery } from '../../../queries/teamQuery';
import { userQuery } from '../../../queries/userQuery';

import type { QueryClient } from '@tanstack/react-query';

export const settingsCodingLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const user = await queryClient.ensureQueryData(userQuery);
	const companyPropertiesData = await queryClient.ensureQueryData(
		companyPropertiesQuery(user?.companyAccountId, { cardprovider: 'tsgo-cardprovider' }),
	);
	const isHsbcCardProvider = companyPropertiesData?.cardprovider === 'HSBC';

	if (isHsbcCardProvider) {
		// we prevent the user from accessing the page if the card provider is HSBC
		throw redirect('/error');
	}

	const codingLists = await queryClient.ensureQueryData(getCodingListsQuery({ skipDisabled: false }));

	const codingEntries = await queryClient.ensureQueryData(
		getCodingListsEntriesQuery({
			codingLists,
		}),
	);

	return {
		user,
		teams: await queryClient.ensureQueryData(teamsQuery({ state: 'active' })),
		allTeams: await queryClient.ensureQueryData(allTeamsQuery),
		codingLists,
		codingEntries,
	};
};
